import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { SendReviewForm } from "@/features/reviews/components/send-review-form"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/review/"
)({
  component: SendReviewPage,
})

/**
 * Choose what to ask them to check and by when, see the email, and send it
 * from the header.
 */
function SendReviewPage() {
  const { individualId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <PageContent>
      <SendReviewForm
        individualId={individualId}
        onSent={(review) =>
          void navigate({
            from: "/$organisation",
            to: "/$organisation/reviews/$reviewId",
            params: { reviewId: review.id },
          })
        }
      />
    </PageContent>
  )
}
